module.exports = __webpack_public_path__ + "labioplastika_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_4_after_tn.jpg
// module id = 1541
// module chunks = 0